import Axios from './axios_wrapper'

export function generateProductKeys (data) {
  return Axios({
    url: `/admin/product_keys`,
    method: 'POST',
    data
  })
}

export function assignProductKey (user_id, data) {
  return Axios({
    url: `/users/${user_id}/product_key`,
    method: 'POST',
    data
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/product_keys.js
// module id = null
// module chunks = 